/* global gtag */

import React, { Component } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";

class EstimateForm extends Component {

  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);
    const paramPairs = [];
    urlParams.forEach((value, key) => {
      paramPairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });

    this.state = {
      keyword: paramPairs.join('&'),
      email: '',
      name: '',
      phone: '',
      message: '',
      from: '',
      to: '',
      size: '',
      hp_check: '',  // honeypot, humans never see or fill this field
      errors: {},  // Single object to store all errors
      return_msg: '',
      flag: false,
      loading: false
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateForm = () => {
    const { email, name, phone, from, to } = this.state;
    const errors = {};

    if (!name) errors.name = 'Required Field';
    if (!email) errors.email = 'Required Field';
    else if (!/^(.+)@(.+)$/.test(email)) errors.email = 'Enter Valid Email';
    if (!phone) errors.phone = 'Required Field';
    if (!from) errors.from = 'Required Field';
    if (!to) errors.to = 'Required Field';

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      this.setState({ return_msg: 'Please Fill All Fields', flag: true });
      return;
    }

    this.setState({ loading: true });
    try {
      const { keyword, email, name, phone, message, from, to, size, hp_check } = this.state;
      // Proof-of-page token: fetched at submit time so it can never be stale; if the
      // fetch fails the marker still lets the submission through (backend flags it).
      let form_token = 'unavailable';
      try {
        const tokenRes = await axios.get(process.env.PUBLIC_URL + "/api/form-token", { timeout: 4000 });
        if (tokenRes.data && tokenRes.data.t) form_token = tokenRes.data.t;
      } catch (tokenErr) { /* proceed with the marker */ }
      const response = await axios.post(process.env.PUBLIC_URL + "/api/submit/estimate",
        { keyword, email, name, phone, message, from, to, size, hp_check, form_token });
      console.log(response);

      // Define a callback to navigate after the conversion report
      const conversionCallback = () => {
        this.props.navigate("/submitted?source=quote");
      };

      // Trigger the conversion report with a single gtag call, using the callback for navigation
      gtag('event', 'conversion', {
        'send_to': 'AW-11127267263/yR1BCJzRp5sYEL-_8rkp',
        'event_callback': conversionCallback
      });

      this.setState({
        return_msg: 'The request has been submitted. Thank you for contacting us!',
        flag: true,
        loading: false
      });
      this.props.navigate("/submitted?source=quote");
    } catch (err) {
      console.log(err);
      this.setState({
        return_msg: 'Unfortunately an error has occurred. We are sorry for the inconvenience and appreciate if you can contact us by phone.',
        flag: true,
        loading: false
      });
    }
  };

  render() {
    const { errors, loading, return_msg, flag } = this.state;

    return (
      <div className="quote-form">
        <div id="message">
          {flag && (
            <div className="alert alert-success">
              <strong>{return_msg}</strong>
            </div>
          )}

        </div>
        <form onSubmit={this.handleSubmit} id="quoteForm">
          {/* Honeypot: hidden checkbox. Autofill never ticks checkboxes, but
              spam bots check every box they find. */}
          <div className="hp-field" aria-hidden="true">
            <input
              type="checkbox"
              name="accept_terms"
              checked={this.state.hp_check !== ''}
              onChange={(e) => this.setState({ hp_check: e.target.checked ? 'on' : '' })}
              tabIndex="-1"
            />
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="input-group">
                <label className="form-field-label" htmlFor="est-name">Name</label>
                <span id="err">{errors.name}</span>
                <input
                  id="est-name"
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange}
                  className="form-control"
                  placeholder="Your name"
                  autoComplete="name"
                />
              </div>
              <div className="input-group">
                <label className="form-field-label" htmlFor="est-email">Email</label>
                <span id="err">{errors.email}</span>
                <input
                  id="est-email"
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  className="form-control"
                  placeholder="you@example.com"
                  autoComplete="email"
                  inputMode="email"
                />
              </div>
              <div className="input-group">
                <label className="form-field-label" htmlFor="est-phone">Phone</label>
                <span id="err">{errors.phone}</span>
                <input
                  id="est-phone"
                  type="tel"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.handleChange}
                  className="form-control"
                  placeholder="(206) 555-0123"
                  autoComplete="tel"
                  inputMode="tel"
                />
              </div>
              <div className="input-group">
                <label className="form-field-label" htmlFor="est-from">Moving From (Address or Zip Code)</label>
                <span id="err">{errors.from}</span>
                <input
                  id="est-from"
                  type="text"
                  name="from"
                  value={this.state.from}
                  onChange={this.handleChange}
                  className="form-control"
                  placeholder="e.g. Seattle, WA or 98371"
                />
              </div>
              <div className="input-group">
                <label className="form-field-label" htmlFor="est-to">Moving To (Address or Zip Code)</label>
                <span id="err">{errors.to}</span>
                <input
                  id="est-to"
                  type="text"
                  name="to"
                  value={this.state.to}
                  onChange={this.handleChange}
                  className="form-control"
                  placeholder="e.g. Phoenix, AZ or 85001"
                />
              </div>
              <div className="input-group">
                <label className="form-field-label" htmlFor="est-size">Size of Move (optional)</label>
                <select
                  id="est-size"
                  name="size"
                  value={this.state.size}
                  onChange={this.handleChange}
                  className="form-control"
                >
                  <option value="">Select…</option>
                  <option value="1 Bedroom Condo/Apartment">1 Bedroom Condo/Apartment</option>
                  <option value="2 Bedroom Condo/Apartment">2 Bedroom Condo/Apartment</option>
                  <option value="3 Bedroom Condo/Apartment">3 Bedroom Condo/Apartment</option>
                  <option value="Townhouse/2 Bedroom House">Townhouse/2 Bedroom House</option>
                  <option value="3 Bedroom House">3 Bedroom House</option>
                  <option value="4 Bedroom House">4 Bedroom House</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div className="form-submit-group col-md-6 col-sm-12">
              <div className="input-group input_group_full_width">
                <label className="form-field-label" htmlFor="est-message">Message (optional)</label>
                <textarea
                  id="est-message"
                  name="message"
                  value={this.state.message}
                  onChange={this.handleChange}
                  className="form-control"
                  maxLength={5000}
                  placeholder="Anything we should know about your move?"
                />
              </div>
              <div className="col-sm-12">
                <button
                  type="submit"
                  className="submit-button btn btn-chos"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
                <div id="simple-msg"></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default function EstimateFormWrapper() {
  const navigate = useNavigate();
  return <EstimateForm navigate={navigate} />;
}
